import React, { lazy, Suspense, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import JwtAuthService from "services/JwtAuthService";
import MenuService from "services/MenuService";

const PainelComercializadora = lazy(() =>
	import("../app-views/painel-comercializadora"),
);

export const ComercializadoraViews = () => {
	useEffect(() => {
		if (JwtAuthService.isLogged()) {
			MenuService.populateMenuData().catch(() => {});
		}
		// Sem polling de /menu: o refresh a cada 30s recria o user no Redux
		// e remonta o painel (modal fecha/abre).
	}, []);

	return (
		<Suspense fallback={<Loading cover="content" />}>
			<Switch>
				<Route
					path={`${APP_PREFIX_PATH}/painel-comercializadora`}
					component={PainelComercializadora}
				/>
				<Redirect
					from={`${APP_PREFIX_PATH}`}
					to={`${APP_PREFIX_PATH}/painel-comercializadora`}
				/>
			</Switch>
		</Suspense>
	);
};

export default ComercializadoraViews;
